export default "__VITE_ASSET__020af14d__"